import { render, staticRenderFns } from "./InitialSetting.vue?vue&type=template&id=d72a609e"
import script from "./InitialSetting.vue?vue&type=script&lang=js"
export * from "./InitialSetting.vue?vue&type=script&lang=js"
import style0 from "./InitialSetting.vue?vue&type=style&index=0&id=d72a609e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports